export const INTERACTION_PROPERTY = 'interaction_id';

type ClickInteraction = Readonly<{ id: string; occurredAt: number }>;
type InteractionFrame = { event: MouseEvent; interaction: ClickInteraction | null };

function interactionId(): string {
  if (globalThis.crypto.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** One tracker owns these dispatch frames. Nested clicks restore their caller's interaction. */
export class ClickInteractions {
  private frames: InteractionFrame[] = [];
  private cleanupTimer: number | null = null;

  begin(event: MouseEvent): void {
    this.current();
    const frame: InteractionFrame = { event, interaction: null };
    this.frames.push(frame);
    if (this.cleanupTimer === null) {
      this.cleanupTimer = window.setTimeout(() => {
        this.cleanupTimer = null;
        this.current();
      }, 0);
    }
    if ((event.type === 'click' && event.button === 0) || (event.type === 'auxclick' && event.button === 1)) {
      frame.interaction = { id: interactionId(), occurredAt: Date.now() };
    }
  }

  current(): ClickInteraction | null {
    while (this.frames.length > 0) {
      const frame = this.frames[this.frames.length - 1]!;
      if (frame.event.eventPhase !== Event.NONE) return frame.interaction;
      this.frames.pop();
    }
    return null;
  }

  clear(): void {
    if (this.cleanupTimer !== null) window.clearTimeout(this.cleanupTimer);
    this.cleanupTimer = null;
    this.frames = [];
  }
}
